import { render, staticRenderFns } from "./ReportTemplateUpdate.vue?vue&type=template&id=b99061ae"
import script from "./ReportTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./ReportTemplateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports